<style>
</style>
<template>
  <div class="searching ">
    <div class="header_box m_clearLR m_tran50">
      <div class="search_box m_floatL">
        <input
          type="text"
          class="seachIpt"
          @keyup.enter="searchSubmit"
          @keyup="searchSubmit"
          v-model="keyword"
          :placeholder="keywordHolder"
        >
        <img src="./../assets/images/search.png" class="search_img">
      </div>
      <div class="search_cancel m_floatL" @click="$router.back(-1)">取消</div>
    </div>
    <div class="search_list_box m_tran50">
      <div class="m_clearLR search_div">
        <div class="m_floatL search_title">故障排除</div>
      </div>
    </div>

    <div class="loadmore_boxTwo m_tran50">
      <div class="m_pointMsg" v-show="gz_msgShow">无相关内容</div>
      <mt-loadmore
        :bottomDistance="bottomDistance"
        ref="loadmore"
        :topDistance="mynum"
        @top-status-change="handleTopChange"
        :bottom-method="getList"
        :bottom-all-loaded="allLoaded"
        :max-distance="150"
      >
        <div class="goods_box m_clearLR">
          <div
            class="goods_divTwo"
            v-for="(item,index) in list"
            @click="toTtInfo(item.id)"
            :key="index"
          >
            <div>{{item.title}}</div>
            <div class="m_clearLR goods_msg_box">
              <div class="m_floatL">{{item.views?item.views:'0'}}人阅读</div>
              <div class="m_floatL createdTime">{{item.created_at|partFilter}}</div>
            </div>
          </div>
        </div>
      </mt-loadmore>

      <div class="servers_box">
        <div class="servers_title">服务提示:</div>
        <div class="servers_content">
          <div>1、如果是打印机手机端打印软件下载，返回软件下载</div>
          <div>2、如果是打印机端驱动软件下载，登录www.buypos.cn/1</div>
          <div>3、如果是扫描枪，所有扫描枪即插即用，不需要驱动</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getKeywords, getArticle } from "@/api/api";
export default {
  data() {
    return {
      list: [],
      num: 3,
      list2: [],
      pageIndex: 1,
      mynum: 200,
      flag: false,
      mysize: 35,
      bottomDistance: 30,
      allLoaded: false,
      pageSize: 20,
      gz_msgShow: false,
      keywordHolder: "佳博GP1324D打印机",
      keyword: "",
      testImg:
        "http://47.106.192.126/media/images/goods/goods_front_image/2018/09/TB229W7jOMnBKNjSZFCXXX0KFXa_931936555.jpg_800x800q90.jpg"
    };
  },
  created() {
    // setTimeout(() => {
    //   getKeywords().then((res)=>{
    //      console.log(res.data)
    //     for(var i = 0 ; i < res.data.length ; i ++){
    //       if(res.data[i].use){
    //         this.keyword = res.data[i].keywordsId[0].value
    //         break
    //       }
    //     }
    //   })
    //   this.getList();
    // }, 500);
    this.keyword = this.$route.query.keyword
    this.keywordHolder = localStorage.getItem("searchWord");
    this.getList();
  },
  filters: {
    //转化时间年月日
    partFilter: function(value, type) {
      if (!value) return "";
      var time = value.split("T")[0];
      var year = time.split("-");
      value = year[0] + "年" + year[1] + "月" + year[2] + "日";
      return value;
    }
  },
  methods: {
    searchCancel() {},
    handleTopChange(status) {
      this.topStatus = status;
    },
    toTtInfo(id) {
      this.$router.push({ path: "/troubleshootingInfo", query: { id: id } });
    },
    searchSubmit() {
      this.pageIndex = 1;
      this.list = [];
      this.getList();
    },
    getList() {
      if (this.flag) {
        return;
      }
      this.flag = true;
      var tempKeyword = this.keyword;
      if (!this.keyword) tempKeyword = this.keywordHolder;
      console.log(this.keyword);
      getArticle(
        "?search=" +
          tempKeyword +
          "&page=" +
          this.pageIndex +
          "&page_size=" +
          this.pageSize
      )
        .then(res => {
          this.pageIndex++;
          var data = res.data.results;
          var gz_flag = false;
          for (var i = 0; i < data.length; i++) {
            if (data[i].article_type == 2) {
              this.list.push(data[i]);
              gz_flag = true;
            }
          }

          var timer = setInterval(() => {
            // this.openTouch();
            if (document.querySelector(".loadmore_box")) {
              clearInterval(timer);
              document.querySelector(".loadmore_box").scrollTop = 0;
            }
          }, 50);
          if (gz_flag == false) {
            this.gz_msgShow = true;
          } else {
            this.gz_msgShow = false;
          }
          this.$refs.loadmore.onBottomLoaded();
          this.flag = false;
        })
        .catch(res => {
          this.flag = false;
          this.$refs.loadmore.onBottomLoaded();
          this.allLoaded = true;
          console.log(res);
        });
    }
  }
};
</script>





// WEBPACK FOOTER //
// src/components/moreTroubleshooting.vue